module.exports = __webpack_public_path__ + "img/WMS_bg3.0afec6c7.png";